import { useState, useEffect } from 'react';
import useInView from './hooks/useInView';
import './Contact.scss';

const Contact = () => {
    const [ref, isVisible] = useInView();
    console.log("Contact visible ?", isVisible);
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        message: '',
    });
    const [status, setStatus] = useState(null);

    // Fonction pour gérer le changement dans les champs du formulaire
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    // Fonction pour envoyer le formulaire
    const handleSubmit = async (e) => {
        e.preventDefault(); // Empêche le rechargement de la page

        try {
            const response = await fetch('/api/send-mail', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });
            if (response.ok) {
                setStatus('success');
                setFormData({ firstName: '', lastName: '', email: '', message: '' }); // Réinitialisation du formulaire
                console.log('message envoyé avec succès');
            } else {
                setStatus('error');
            }
        } catch (error) {
            console.error('Erreur lors de l\'envoi du message:', error);
            setStatus('error');
        }
    };

    useEffect(() => {
        if (status) {
            const timer = setTimeout(() => setStatus(null), 5000);
            return () => clearTimeout(timer);
        }
    }, [status]);
    return (

<div ref={ref} className="contact-container">
  <div
    className={`contact-content-wrapper ${isVisible ? "fade-in" : ""} ${
      status ? "blurred" : ""
    }`}
  >
    <div className="contact-header">
      <div className="contact-hacienda-logo">
        <img src="contact.webp" alt="titre contact" />
      </div>
    </div>
    <div className="contact-content">
      <div className="contact-form">
        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor="firstName"> Prénom </label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              placeholder="Prénom"
              value={formData.firstName}
              onChange={handleChange}
              required
            />
            <label htmlFor="lastName"> Nom </label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              placeholder="Nom"
              value={formData.lastName}
              onChange={handleChange}
              required
            />
          </div>
          <div>
            <label htmlFor="email"> Email </label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <label htmlFor="message"> Votre message </label>
            <textarea
              id="message"
              name="message"
              rows="4"
              placeholder="Votre message..."
              value={formData.message}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit">Envoyer</button>
        </form>
      </div>
    </div>
  </div>

  {/* Le popup par-dessus */}
  {status && (
    <div className="popup-message">
      {status === "success" && (
        <p className="success-message">Message envoyé avec succès !</p>
      )}
      {status === "error" && (
        <p className="error-message">Erreur lors de l&apos;envoi.</p>
      )}
    </div>
  )}
</div>
    );
};

export default Contact; 